import axios from 'axios';

import { ResponseObj, UltrassomFormData } from '../../../back/src/types';
import { Ultrassom } from '../../../back/src/entity/Ultrassom';

const criaUltrassom = async (formData: UltrassomFormData): Promise<ResponseObj<Ultrassom>> => {
  const res = await axios.post<ResponseObj<Ultrassom>>('ultrassons', formData);
  return res.data;
};

const alteraUltrassom = async (formData: UltrassomFormData): Promise<ResponseObj<Ultrassom>> => {
  const res = await axios.put<ResponseObj<Ultrassom>>('ultrassons', formData);
  return res.data;
};

export default {
  criaUltrassom,
  alteraUltrassom,
};
